import { render, staticRenderFns } from "./PatientExternalMenu.vue?vue&type=template&id=65fd4b04&scoped=true&"
import script from "./PatientExternalMenu.vue?vue&type=script&lang=ts&"
export * from "./PatientExternalMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd4b04",
  null
  
)

export default component.exports